"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _focusMixin = require("../focusMixin");
var _listResetMixin = require("../listResetMixin");
var ListboxMixin = function ListboxMixin(props) {
  var size = props.size;
  return (0, _styledToken.default)({
    borderWidth: 'Input.borderWidth',
    borderColor: 'Input.borderColor',
    borderRadius: 'Listbox.borderRadius',
    maxHeight: "Listbox.sizes." + size
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      maxHeight = _ref.maxHeight;
    return (0, _styledComponents.css)(["border:", "px solid ", ";border-radius:", "px;overflow-y:auto;max-height:", ";box-sizing:border-box;", " ", ""], borderWidth, borderColor, borderRadius, maxHeight ? maxHeight + "px" : '100%', (0, _listResetMixin.listResetMixin)(props), (0, _focusMixin.focusMixin)(props));
  })(props);
};
exports.ListboxMixin = ListboxMixin;